/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import SubsriptionComponent from './main';
import NewSubsriptionComponent from './new/main';

export const subscriptions = (context, next) => {
    context.primary = <SubsriptionComponent />;
    next();
};

export const newSubscription = (context, next) => {
    context.primary = <NewSubsriptionComponent />;
    next();
};